export default () => {
  return {
    lastSearchedValue: '',
    layerError: '',
    listError: '',
    listViewIsAToZ: false,
    locationCoordinates: null,
    projectsFilter: 'projectsLocation',
    projectsList: [],
    requestSummary: false,
    selectedFeatureSummary: {},
    selectedLocation: {
      isCollection: false,
      magicKey: '',
      text: '',
    },
    suggestedLocations: [],
    suggestedProjects: [],
    suggestionsModel: '',
    userGuideVisible: false,
  };
};
